// extracted by mini-css-extract-plugin
export var gif = "_me-0";